import type { MonitoringOptions } from '@web-rendering/groundcontrol-monitoring';
import { reportError } from '@web-rendering/groundcontrol-monitoring';
import { useErrorBoundary } from 'preact/hooks';
import { usePayload } from '../../payload/provider';

export const useErrorHandler = (message?: string) => {
  const payload = usePayload() ?? undefined;
  const enhancement = payload?.enhancement ?? null;

  return useErrorBoundary((error) => {
    const options: MonitoringOptions = {
      callerId: payload?.network.callerId,
      networkId: payload?.network.networkId,
      partnerId: payload?.creative.partnerId,
      payload,
      enhancement
    };

    if (message && error instanceof Error) {
      error.message = `${message}: ${error.message}`;
    }

    reportError(error, options);
  });
};
